<template>
  <!--
      作者：zhuchangtao
      时间：2021-01-18
      描述：发货单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="发货单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入发货单号"></el-input></el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部发货单" name="all"></el-tab-pane>
          <el-tab-pane :label="'待拣货(' + order_count.pick + ')'" name="pick"></el-tab-pane>
          <el-tab-pane :label="'待派送(' + order_count.assign + ')'" name="assign"></el-tab-pane>
          <el-tab-pane :label="'待取货(' + order_count.take + ')'" name="take"></el-tab-pane>
          <el-tab-pane :label="'待收货(' + order_count.receipt + ')'" name="receipt"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_no" label="发货单信息" width="400">
            <template slot-scope="scope">
              <div class="order-code" v-if="!scope.row.is_top_row">
                <span class="c_main">发货单ID：{{ scope.row.order_id }}</span>
                <span class="c_main">发货单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
              </div>

            </template>
          </el-table-column>

        <el-table-column prop="" label="用户信息">
          <template slot-scope="scope" v-if="!scope.row.is_top_row">
            <div>{{ scope.row.user.nickName }}</div>
            <div class="gray9">ID：({{ scope.row.user.user_id }})</div>
          </template>
        </el-table-column>


          <el-table-column prop="name" label="收货信息">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">收货人姓名:{{ scope.row.name }}</span><br />
              <span class="gray9">收货人电话:{{ scope.row.phone }}</span><br />
              <span class="gray9">收货人地址:{{ scope.row.address}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pick_type.text" label="取货方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="blue">{{ scope.row.pick_type.text }}</span>

            </template>
          </el-table-column>
          <el-table-column prop="pick_type.text" label="状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="red" v-if="scope.row.pick_type.value == 10 && scope.row.picking_status.value == 10
                  && scope.row.order_status.value == 10">{{ scope.row.picking_status.text }}</span>
              <span class="red" v-if="scope.row.picking_status.value == 20 && scope.row.assign_status.value == 10
                  && scope.row.order_status.value == 10">{{ scope.row.assign_status.text }}</span>
              <span class="red" v-if="scope.row.assign_status.value == 20 && scope.row.take_status.value == 10
                  && scope.row.order_status.value == 10">{{ scope.row.take_status.text }}</span>
              <span class="red" v-if="scope.row.take_status.value == 20 && scope.row.receipt_status.value == 10
                      && scope.row.order_status.value == 10">{{ scope.row.receipt_status.text }}</span>
              <span class="green" v-if="scope.row.order_status.value == 30">{{ scope.row.order_status.text }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button @click="detailClick(scope.row)" type="text" size="small" v-auth="'/plus/distribution/order/detail'">订单详情</el-button>
              <el-button
                  v-if="scope.row.pick_type.value == 10 && scope.row.picking_status.value == 10
                  && scope.row.order_status.value == 10"
                 @click="addClick(scope.row)"
                 type="text"
                 size="small"
                 v-auth="'/plus/distribution/picking/add'"
               >
                 去拣货
               </el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <!--拣货-->
    <Add v-if="open_add" :open_add="open_add" :form="userModel"  @closeDialog="closeDialogFunc($event, 'add')"></Add>
  </div>
</template>

<script>
import DistributionApi from '@/api/distribution.js';
import Add from './dialog/Add.vue';
import qs from 'qs';
export default {
  components: {
    /*编辑组件*/
    Add,

  },
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        order_no: '',
        create_time: ''
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        pick: 0,
        assign: 0,
        take: 0,
        receipt:0
      },
      /*当前编辑的对象*/
      userModel: {},
      /*是否打开添加弹窗*/
      open_add: false,
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      DistributionApi.orderlist(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              user:item.user,
              is_top_row: true
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;
          self.totalDataNumber = res.data.list.total;

          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(item) {
      this.userModel = item;
      this.open_add = true;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }

    },
    /*订单详情*/
    detailClick(row){
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/plus/distribution/order/detail',
        query: {
          order_id: params
        }
      });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.distribution.order/export?' + qs.stringify(this.searchForm);
    }
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/distribution/order/index.vue